<template>
  <div class="marquee-scroll" ref="container">
    <div class="marquee-wrapper" ref="wrapper">
      <div class="marquee-content" ref="content" :style="contentStyle">
        <slot></slot>
      </div>
      <div class="marquee-content" :style="contentStyle" aria-hidden="true">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarqueeScroll',
  props: {
    speed: {
      type: Number,
      default: 150 // 每秒滚动的像素数，调整此值来控制滚动速度
    },
    minDuration: {
      type: Number,
      default: 5000 // 最小动画时长（毫秒）
    },
    maxDuration: {
      type: Number,
      default: 30000 // 最大动画时长（毫秒）
    }
  },
  data() {
    return {
      contentWidth: 0,
      containerWidth: 0,
      calculatedDuration: 10000, // 初始化动画时长
      resizeObserver: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.calculateDimensions();

      // 使用 ResizeObserver 监听尺寸变化
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.calculateDimensions);
        this.resizeObserver.observe(this.$refs.container);
        if (this.$refs.content) {
          this.resizeObserver.observe(this.$refs.content);
        }
      } else {
        // 降级方案：监听窗口resize
        window.addEventListener('resize', this.calculateDimensions);
      }
    });
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    } else {
      window.removeEventListener('resize', this.calculateDimensions);
    }
  },
  methods: {
    calculateDimensions() {
      this.$nextTick(() => {
        if (this.$refs.content && this.$refs.container) {
          this.contentWidth = this.$refs.content.scrollWidth;
          this.containerWidth = this.$refs.container.offsetWidth;

          // 计算动画时长：总距离 / 每秒滚动的像素数
          if (this.contentWidth > 0 && this.containerWidth > 0) {
            const totalDistance = this.contentWidth + this.containerWidth;
            const durationInSeconds = totalDistance / this.speed; // 使用速度计算时长

            // 将时长限制在最小和最大范围内，转换为毫秒
            this.calculatedDuration = Math.max(
                this.minDuration,
                Math.min(this.maxDuration, durationInSeconds * 1000)
            );
          }
        }
      });
    }
  },
  computed: {
    contentStyle() {
      return {
        animationDuration: `${this.calculatedDuration}ms`, // 使用计算的动画时长
        paddingRight: `${this.containerWidth / 2}px` // 动态间距，确保无缝衔接
      };
    }
  }
};
</script>

<style scoped>
.marquee-scroll {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.marquee-wrapper {
  display: flex;
  min-width: 100%;
}

.marquee-content {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  flex-shrink: 0;
  height: 100%;
  animation: marquee linear infinite;
}

/* 深度选择器确保插槽内容样式正确 */
.marquee-content ::v-deep img {
  vertical-align: middle;
  margin-right: 8px;
  height: 24px; /* 统一图标高度 */
  object-fit: contain;
}

.marquee-content ::v-deep span {
  vertical-align: middle;
  line-height: 1.5;
}

@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>



// WEBPACK FOOTER //
// MarqueeScroll.vue?75f1dc8a